import React from 'react';
import { action, computed } from 'mobx';
import { observer } from 'mobx-react';

import { Stack, Checkbox } from '@chakra-ui/react';

import {
  FilterField,
  FilterOps,
  FilterInput,
  ValueInputType,
} from '../filterModels';

const EnumFilterView = observer(({ filter }) => {
  const { filterInputs } = filter.filterField;
  const selectedValues = {};
  filterInputs.forEach(filterInput => {
    selectedValues[filterInput.value.value] = filterInput;
  });
  const valsEnum = filter.valuesEnum;

  // Add a badge here which is a bit specific to statuses?
  return (
    <Stack py={3} px={2} backgroundColor='#fbfbfb'>
      {Object.keys(valsEnum).map((key, i) => (
        <Checkbox
          isChecked={(selectedValues[key] && true) || false}
          onChange={e => filter.ChangeEnumVal(key, e.target.checked)}
          key={i}
          color='black'
        >
          {valsEnum[key].title}
        </Checkbox>
      ))}
    </Stack>
  );
});

export class EnumFilter {
  /* Filters represents UI state of the filter. */
  static View = EnumFilterView;
  static OpJoin = 'OR';

  constructor({ fieldName, fieldTitle, valuesEnum, selected, filterInputs }) {
    this.filterField = new FilterField({
      filter: this,
      filterInputs,
      fieldName,
      fieldTitle,
      selected,
    });
    this.valuesEnum = valuesEnum;
  }

  @action ChangeEnumVal = (key, checked) => {
    if (!Object.keys(this.valuesEnum).includes(key)) {
      console.error('Invalid Enum value');
    }
    const { filterInputs } = this.filterField;
    if (checked) {
      filterInputs.push(
        new FilterInput({
          field: this.filterField.name,
          value: key,
          type: ValueInputType.STRING,
          operator: FilterOps.EQ,
        }),
      );
    } else {
      const ix = filterInputs.findIndex(input => input.value.value === key);
      if (ix !== -1) {
        filterInputs.splice(ix, 1);
      }
    }
  };

  @computed get isValid() {
    return true;
  }
}
